/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.UploadDocList";
        class UploadDocListWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("UploadDocListWidgetTypeClass.createInstance()");
                    return new UploadDocListWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("UploadDocListWidgetTypeClass._storeHtml()");
                    UploadDocListWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("UploadDocListWidgetTypeClass::constructor");
                if (UploadDocListWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/UploadDocList/upload-doc-list.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.UploadDocListWidgetTypeClass = UploadDocListWidgetTypeClass;
        class UploadDocListWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._noRecords = null;
                this._loader = null;
                this._listHolder = null;
                this._filterText = null;
                this._showFilterSpan = null;
                this._hideFilterSpan = null;
                this._filterPanel = null;
                this._presentAsButtons = null;
                this._buttonsVertical = null;
                this._docTypes = [];
                this._currentDocType = null;
                this._dataList = null;
                this._buttonPalette = null;
                this.presentInstance = () => {
                    this._log.info("UploadDocListWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = UploadDocListWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._noRecords = this._container.querySelector('#uploadDocListNoRecords');
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._listHolder = this._container.querySelector('#uploadDocListHolder');
                    this._filterText = this._container.querySelector('#uploadDocListFilter');
                    this._showFilterSpan = this._container.querySelector('.uploadDocListShowFilter');
                    this._hideFilterSpan = this._container.querySelector('.uploadDocListCancelFilter');
                    this._filterPanel = this._container.querySelector('.widget__filter');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#uploadDocListWidgetTitle'), 'STR_WPT_UPLOAD_DOC_LIST');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._container.querySelector('#uploadDocListNoRecordsMessage'), 'STR_WPT_NOINFO');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#uploadDocListLoading'), 'STR_WPT_LOADING');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'placeholder', 'STR_WPT_FILTERLIST');
                    this._core.Helper.setElementTranslationAttribute(this._filterText, 'aria-label', 'STR_WPT_FILTERLIST');
                    this._filterText.addEventListener('keyup', this._doFilter);
                    this._showFilterSpan.addEventListener('click', this._showFilter);
                    this._hideFilterSpan.addEventListener('click', this._hideFilter);
                    this._container.querySelector('#uploadDocListNoRecordsReload').addEventListener('click', this._loadDocTypeData);
                    this._container.querySelector('.uploadDocListClearFilter').addEventListener('click', this._clearFilter);
                    if (this._presentAsButtons && !this._buttonsVertical) {
                        this._listHolder.classList.add('widget__body-item--no-padding');
                    }
                    if (this._presentAsButtons) {
                        let usePrimary = false;
                        if (this._config.hasOwnProperty('SuppressHeading') && this._config.SuppressHeading === true) {
                            usePrimary = true;
                        }
                        let bpConfig = {
                            Orientation: this._buttonsVertical ? 'Vertical' : 'Horizontal',
                            SuppressNoItemsBanner: true,
                            UsePrimaryColour: usePrimary
                        };
                        this._buttonPalette = new Widgets.ComponentButtonPalette(this._core, this._listHolder, this, bpConfig, this._docTypeClicked);
                        this._buttonPalette.present();
                    }
                    else {
                        let listConfig = {
                            SelectItemCallback: this._docTypeClicked
                        };
                        this._dataList = new Widgets.ComponentDataList(this._core, this._listHolder, this, listConfig);
                        this._dataList.present();
                    }
                    this._loadDocTypeData();
                    this._type.instanceReady(this.getHandle());
                };
                this.returnedToHomepage = () => {
                    this._log.info("UploadDocListWidgetInstanceClass.returnedToHomepage()");
                    this._clearSelection();
                };
                this._loadDocTypeData = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._loadDocTypeData()");
                    this._hideFilter();
                    this._core.Functions.hideElement(this._noRecords);
                    this._core.Functions.showElement(this._loader);
                    this._core.OBHelper.LoadUploadDocumentTypes(this._docTypesLoaded);
                };
                this._docTypesLoaded = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._docTypesLoaded()");
                    this._core.Functions.hideElement(this._loader);
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearDisplay();
                    }
                    else {
                        this._dataList.clearList();
                    }
                    this._docTypes = [];
                    let conf = this._config;
                    if (conf.hasOwnProperty('DocTypes') && conf.DocTypes.length > 0) {
                        if (conf.DocTypes[0] === '*') {
                            this._docTypes.push(...this._core.OBHelper.UploadDocumentTypes);
                        }
                        else {
                            conf.DocTypes.forEach(dtName => {
                                let checkDocType = this._core.OBHelper.UploadDocumentTypes.find(dt => dt.Name == dtName);
                                if (checkDocType)
                                    this._docTypes.push(checkDocType);
                            });
                        }
                    }
                    else {
                        this._docTypes.push(...this._core.OBHelper.UploadDocumentTypes);
                    }
                    if (this._docTypes.length > 0) {
                        this._presentDocTypes();
                    }
                    else {
                        this._core.Functions.showElement(this._noRecords);
                    }
                };
                this._presentDocTypes = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._presentDocTypes()");
                    let length = this._docTypes.length;
                    if (this._presentAsButtons) {
                        let buttonOptions = [];
                        for (let i = 0; i < length; i++) {
                            let docType = this._docTypes[i];
                            let buttonOption = {
                                Identifier: docType.Id.toString(10),
                                Label: docType.Name
                            };
                            buttonOptions.push(buttonOption);
                        }
                        this._buttonPalette.displayOptions(buttonOptions);
                    }
                    else {
                        let listData = {
                            Items: []
                        };
                        for (let i = 0; i < length; i++) {
                            let docType = this._docTypes[i];
                            let itemData = {
                                Id: docType.Id.toString(10),
                                DisplayName: docType.Name
                            };
                            listData.Items.push(itemData);
                        }
                        this._dataList.displayData(listData);
                    }
                };
                this._docTypeClicked = (id) => {
                    this._log.info("UploadDocListWidgetInstanceClass._docTypeClicked()");
                    let config = this._config;
                    let docTypeId = Number(id);
                    // THIS CLEARS CURRENT DOC TYPE - only reset after this call
                    this._clearSelection();
                    this._currentDocType = this._docTypes.find(t => t.Id == docTypeId);
                    if (this._presentAsButtons) {
                        this._buttonPalette.selectOption(id);
                    }
                    else {
                        this._dataList.selectItem(id);
                    }
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCTYPE_SELECTED_UPLOAD);
                    navEvent.ActivationID = docTypeId;
                    navEvent.PrimaryContext = this._currentDocType;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = "Upload";
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    // Add transfer widgets if we are moving
                    if (targetLayoutName != this._currentLayout) {
                        if (config.hasOwnProperty("ForwardOtherWidgets")) {
                            navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                        }
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._clearSelection = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._clearSelection()");
                    if (this._presentAsButtons) {
                        this._buttonPalette.clearOptionSelection();
                    }
                    else {
                        this._dataList.clearItemSelection();
                    }
                    this._currentDocType = null;
                };
                this._showFilter = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._showFilter()");
                    this._core.Functions.hideElement(this._showFilterSpan);
                    this._core.Functions.showElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._filterPanel);
                    this._filterText.focus();
                };
                this._hideFilter = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._hideFilter()");
                    this._core.Functions.hideElement(this._hideFilterSpan);
                    this._core.Functions.showElement(this._showFilterSpan);
                    this._core.Functions.hideElement(this._filterPanel);
                    this._clearFilter();
                };
                this._clearFilter = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._clearFilter()");
                    this._core.Functions.clearAndFocusInputElement(this._filterText);
                    this._doFilter();
                };
                this._doFilter = () => {
                    this._log.info("UploadDocListWidgetInstanceClass._doFilter()");
                    let filterText = this._filterText.value;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("filtering with: " + filterText);
                    }
                    if (this._presentAsButtons) {
                        this._buttonPalette.filterOptions(filterText);
                    }
                    else {
                        this._dataList.filterItems(filterText);
                    }
                };
                this.getDocumentType = () => {
                    this._log.info("UploadDocListWidgetInstanceClass.getDocumentType()");
                    return this._currentDocType;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("UploadDocListWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                let conf = config;
                this._buttonsVertical = true;
                if (conf.hasOwnProperty('Type') && conf.Type === 'Buttons') {
                    this._presentAsButtons = true;
                    if (conf.hasOwnProperty('ButtonsVertical') && !conf.ButtonsVertical) {
                        this._buttonsVertical = false;
                    }
                }
                else {
                    this._presentAsButtons = false;
                }
            }
            activate(context) {
                this._log.info("UploadDocListWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                switch (context.ActivationType) {
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_TO_ADVERTISE:
                        let capabilityEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_CAPABILITY_PUBLISHED);
                        capabilityEvent.ActivationID = 0;
                        capabilityEvent.PrimaryContext = ["DocTypeChooser"];
                        capabilityEvent.Layout = this._currentLayout;
                        this._core.Navigation.Details.requestActivation(capabilityEvent);
                        break;
                    case WPTNamespace.Navigation.LayoutActivationType.REQUEST_DOC_UPLOAD_INFO:
                        if (this._currentDocType) {
                            let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.RESPONSE_UPLOAD_DOCTYPE);
                            navEvent.ActivationID = this._currentDocType.Id;
                            navEvent.PrimaryContext = this._currentDocType;
                            navEvent.Layout = this._currentLayout;
                            this._core.Navigation.Details.requestActivation(navEvent);
                        }
                        break;
                }
            }
        }
        UploadDocListWidgetInstanceClass.HtmlData = null;
        Widgets.UploadDocListWidgetInstanceClass = UploadDocListWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
